import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

export default function ThankYou() {
  return (
    <main data-testid="thank-you-page" className="pt-28 min-h-screen bg-[#faf6ef]">
      <section className="py-24 md:py-32">
        <div className="max-w-[900px] mx-auto px-6 md:px-10 text-center">
          <div className="w-16 h-16 rounded-full bg-[#8a9a7b]/15 flex items-center justify-center mx-auto mb-8">
            <Check size={28} strokeWidth={1.5} className="text-[#8a9a7b]" />
          </div>
          <div className="text-[#b4462a] text-xs tracking-[0.3em] uppercase mb-4">Received</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[1.05] tracking-tight font-light mb-6">Thank you.</h1>
          <p className="text-lg text-[#1a1a1a]/75 max-w-xl mx-auto leading-[1.8] mb-12">A specialist from our export desk will write back within one business day. In the meantime:</p>

          <div className="grid sm:grid-cols-3 gap-4 text-left">
            <Link to="/our-craft" className="group p-6 border border-[#1a1a1a]/15 hover:border-[#1e2a5a] transition bg-white" data-testid="ty-craft">
              <div className="text-xs tracking-[0.25em] uppercase text-[#8a9a7b] mb-2">Read</div>
              <div className="font-serif text-xl text-[#1e2a5a] mb-2">Our Craft</div>
              <ArrowRight size={16} strokeWidth={1.5} className="text-[#b4462a] group-hover:translate-x-1 transition" />
            </Link>
            <Link to="/projects" className="group p-6 border border-[#1a1a1a]/15 hover:border-[#1e2a5a] transition bg-white" data-testid="ty-projects">
              <div className="text-xs tracking-[0.25em] uppercase text-[#8a9a7b] mb-2">Browse</div>
              <div className="font-serif text-xl text-[#1e2a5a] mb-2">Case Studies</div>
              <ArrowRight size={16} strokeWidth={1.5} className="text-[#b4462a] group-hover:translate-x-1 transition" />
            </Link>
            <a href="https://instagram.com/indus.home" target="_blank" rel="noreferrer" className="group p-6 border border-[#1a1a1a]/15 hover:border-[#1e2a5a] transition bg-white" data-testid="ty-instagram">
              <div className="text-xs tracking-[0.25em] uppercase text-[#8a9a7b] mb-2">Follow</div>
              <div className="font-serif text-xl text-[#1e2a5a] mb-2">@indus.home</div>
              <ArrowRight size={16} strokeWidth={1.5} className="text-[#b4462a] group-hover:translate-x-1 transition" />
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
